import { render, staticRenderFns } from "./tableTwo.vue?vue&type=template&id=77ca2d99&scoped=true&"
import script from "./tableTwo.vue?vue&type=script&lang=js&"
export * from "./tableTwo.vue?vue&type=script&lang=js&"
import style0 from "./tableTwo.vue?vue&type=style&index=0&id=77ca2d99&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ca2d99",
  null
  
)

export default component.exports